export const selectError = state => state.contacts.error;
export const selectLoading = (state) => state.contacts.isLoading;
export const selectAllConatacts = (state) => state.contacts.items;

